import { SVGProps } from "react";

function SvgComponent(props: SVGProps<SVGSVGElement>) {
  return <svg
    width="70"
    height="70"
    viewBox="0 0 70 70"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_4845_28558)">
      <circle cx="35" cy="33" r="25" fill="white" />
    </g>
    <path
      d="M47.5002 33C47.5002 26.1 41.9002 20.5 35.0002 20.5C28.1002 20.5 22.5002 26.1 22.5002 33C22.5002 39.05 26.8002 44.0875 32.5002 45.25V36.75H30.0002V33H32.5002V29.875C32.5002 27.4625 34.4627 25.5 36.8752 25.5H40.0002V29.25H37.5002C36.8127 29.25 36.2502 29.8125 36.2502 30.5V33H40.0002V36.75H36.2502V45.4375C42.5627 44.8125 47.5002 39.4875 47.5002 33Z"
      fill="#1877F2"
    />
    <defs>
      <filter
        id="filter0_d_4845_28558"
        x="0"
        y="0"
        width="70"
        height="70"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="5" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_4845_28558"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_4845_28558"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
}

export default SvgComponent;
